import Page from 'src/components/page/page';
import useScnEventsList from './scn-events-list.hook';
import { Container } from '@mui/system';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import { Box, Button } from '@mui/material';
import { paths } from 'src/routes/paths';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';

export default function ScnEventsList() {
  const { TABLEHEADER, loadingScnEventsList, scnEventsList, navigate } = useScnEventsList();

  return (
    <Page title="Lista de Eventos SCN">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Eventos SCN"
          links={[]}
          action={
            <Button variant="contained" onClick={() => navigate(paths.dashboard.scnEventCreate)}>
              Cadastrar Evento SCN
            </Button>
          }
        />
        {loadingScnEventsList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={scnEventsList}
            header={TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => navigate(paths.dashboard.scnEventDetails(id))}
          />
        )}
      </Container>
    </Page>
  );
}
